import * as React from 'react';
import { IconProps } from '../types';

export const ChartJsIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 200, ...props }, forwardedRef) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 192 192" 
        {...props} 
        ref={forwardedRef}><path fill="#36A2EB" d="M161.271 96.556c-22.368.439-17.709 14.599-33.473 18.18-16.014 3.638-18.542-39.111-34.552-39.111-16.012 0-19.559 41.526-39.608 70.034l-.572.807 42.985 24.813 65.22-37.651z"/><path fill="#FFCE56" d="M161.271 95.267c-7.488-9.61-12.567-20.658-23.494-20.658-19.337 0-14.249 31.545-35.62 31.545-21.373 0-23.62-33.931-47.832-2.035-7.715 10.163-13.925 21.495-18.803 32.218l60.529 34.943 65.22-37.651z"/><path opacity=".8" fill="#FE6184" d="M30.829 108.334c7.338-20.321 10.505-36.779 24.514-36.779 21.371 0 26.458 60.039 44.779 53.931 18.318-6.105 16.282-38.669 44.779-38.669 5.424 0 10.962 3.323 16.371 8.698v38.113l-65.22 37.651-65.222-37.651v-25.294z"/><path fill="#E7E9ED" d="m96 176-69.292-39.999V56L96 16l69.292 40v80zm-61.151-44.699L96 166.602l61.151-35.301V60.7L96 25.399 34.849 60.7z"/></svg>
  )
);

ChartJsIcon.displayName = 'ChartJsIcon';